<template>
  <div class="Tmall-goods">
    <NavBar :class="{ 'nav-bar': navBar }" :iconColor="'#fff'">
      <img
        slot="title"
        src="@/assets/goods/Tmall-title.png"
        class="title-img"
      />
    </NavBar>
    <img src="@/assets/goods/Tmall-back.png" class="back-img" />
    <div class="search-layout" :class="{ 'nav-bar': navBar }">
      <div class="search">
        <div class="search-input" >
          <img src="@/assets/goods/icon-search@2x.png" class="search-icon" />

          <input class="input" placeholder="请输入关键词" v-model="goodsName" type="text" />
          <div class="search-btn" @click="searchGoods">搜索</div>
        </div>
      </div>

    </div>
    <div class="goods-layout">
      <GoodsList ref="goodsList" tagText="天猫商品" tagType="Tmall"></GoodsList>
    </div>
  </div>
</template>

<script>
import NavBar from "@/layout/nav-bar/nav-bar.vue";
import GoodsList from "../components/GoodsList/GoodsList";

export default {
  components: {
    NavBar,
    GoodsList,
  },
  mounted() {
    addEventListener("scroll", this.handleScroll, true);
  },
  data() {
    return {
      navBar: false,
      showSearch: false,
      goodsName:'',
    };
  },
  methods: {
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 40) {
        this.navBar = true;
      } else {
        this.navBar = false;
      }
    },
    searchGoods() {
      if (this.goodsName !== undefined && this.goodsName !== "") {
        this.$refs.goodsList.selectGoodsList(this.goodsName);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.Tmall-goods {
  position: relative;
  width: 100vw;
  min-height: 100vh;

  .back-img {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 179px;
    z-index: -1;
  }
}

.nav-bar {
  background-color: #9356fe;
}

.title-img {
  width: 104px;
  height: 32px;
}

.search-layout {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  box-sizing: border-box;
}

.goods-layout {
  padding-top: 118px;
}


.search {
  padding: 6px 13px 13px 13px;
  .search-input {
    position: relative;
    display: flex;
    align-items: center;
    height: 39px;
    background: rgb(255, 255, 255);
    border-radius: 21px;
    padding-left: 16px;
    padding-right: 3px;
    .search-icon {
      width: 17px;
      height: 17px;
    }
    .input {
      margin-left: 10px;
      font-size: 16px;
      border: none;
      font-weight: 400;
      color: #999;
    }
    .search-btn {
      position: absolute;
      top: 50%;
      right: 3px;
      transform: translateY(-50%);
      width: 74px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      border-radius: 34px;
      font-size: 18px;
      color: #fff;
      background: linear-gradient(90deg, #AC78FE 0%, #8D4EFE 100%)
    }
  }
}
</style>
